export default __webpack_public_path__ + "static/media/Sample.ea77500c.csv";